export const warn = (message: string) => {
  console.warn(`[YandexMetrica]: ${message}`);
};
